import appGlobalScript from '/tmp/builds/5MRsrR2d8/0/TRUMPF-corp/trumpf-ux/apps/ai-in-service/node_modules/@trumpf/ux.ui/dist/collection/globals/ux.ui.core.js';
export const globalScripts = appGlobalScript;
